import actionTypes from "../actionTypes";
import * as zpCStavZiadostiUtils from "../../utils/ciselniky/zpCStavZiadostiUtils";

export const changeStavZiadosti = (stavZiadosti) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_STAV_ZIADOSTI,
      data: stavZiadosti,
    });
  };
};
const getZP_C_STAV_ZIADOSTI_Request = () => ({
  type: actionTypes.GET_ZP_C_STAV_ZIADOSTI_REQUEST,
});
const getZP_C_STAV_ZIADOSTI_Success = (res) => ({
  type: actionTypes.GET_ZP_C_STAV_ZIADOSTI_SUCCESS,
  res,
});
const getZP_C_STAV_ZIADOSTI_Failure = (error) => ({
  type: actionTypes.GET_ZP_C_STAV_ZIADOSTI_FAILURE,
  error,
});
export const getZP_C_STAV_ZIADOSTI = () => {
  return async (dispatch) => {
    try {
      dispatch(getZP_C_STAV_ZIADOSTI_Request());
      let res = await zpCStavZiadostiUtils.getZP_C_STAV_ZIADOSTI();
      dispatch(getZP_C_STAV_ZIADOSTI_Success(res));
    } catch (error) {
      dispatch(getZP_C_STAV_ZIADOSTI_Failure(error));
    }
  };
};
